import angular from "angular";
import * as _ from "lodash";

angular.module("webTools").controller("HeaderCtrl", [
  "$scope",
  "$injector",
  "Auth",
  "$ngRedux",
  "$rootScope",
  function($scope, $injector, Auth, $ngRedux, $rootScope) {
    $scope.store = $ngRedux;
    
    $scope.kendo = {} || $scope.kendo;
    $scope.breadcrumb = $rootScope.breadcrumb;
    $scope.isElectron = (window.dl && window.dl.isElectron) || false;

    $scope.userName = "";
    $scope.repository = "";
    $scope.isLoggedIn = false;
    $scope.showQuickSearch = true;
    $scope.showWebView = false;

    if ($injector.has("CustomMenu")) {
      $scope.customMenu = $injector.get("CustomMenu");
    }

    $scope.searchOptionsEmpty = function() {
      return (
        _.find($scope.searchOptions, function(option) {
          return option.id < 7 && option.checked === true;
        }) === undefined
      );
    };

    $scope.openWebHelp = function() {
      window.launchLegacyDialog("web-help");
    };

    $scope.$on('logout', () => {
      setTimeout(() => {
        Auth.logout()
        $scope.isLoggedIn = false;
        $scope.$apply()
      })
    })

    $scope.$watch(
      function() {
        return Auth.getAllowedNodes();
      },
      function(allowedNodes) {

        $scope.showQuickSearch = _.includes(allowedNodes, 'search');

        $scope.userName = Auth.getUsername();
        $scope.repository = Auth.getRepository();
        $scope.isLoggedIn = Auth.loggedIn();

        const store = $ngRedux.getState();

        $scope.showWebView = Auth.isWebView() || store.app.webViewMode;
      }
    );
  }
]);

angular.module("webTools").directive("wtHeader", function() {
  return {
    restrict: "E",
    replace: true,
    transclude: false,
    templateUrl: "/partials/header.html"
  };
});
